import { asyncComponent } from 'react-async-component';

const Login = asyncComponent({
  resolve: () => import('../component/login/login.js')
});
const Overview = asyncComponent({
  resolve: () => import("../component/overview/content.js")
})
const Statis = asyncComponent({
  resolve: () => import("../component/statis/content.js")
})
const Down = asyncComponent({
  resolve: () => import("../component/down/content.js")
})
const Product = asyncComponent({
  resolve: () => import("../component/product/content.js")
})
const Productex = asyncComponent({
  resolve: () => import("../component/productex/content.js")
})
const Sub = asyncComponent({
  resolve: () => import("../component/sub/content.js")
})
const Submanage = asyncComponent({
  resolve: () => import("../component/submanage/content.js")
})
const Account = asyncComponent({
  resolve: () => import("../component/account/content.js")
})
const Type = asyncComponent({
  resolve: () => import("../component/type/content.js")
})
const School = asyncComponent({
  resolve: () => import("../component/school/content.js")
})
const Help = asyncComponent({
  resolve: () => import("../component/help/content.js")
})
const Search = asyncComponent({
  resolve: () => import("../component/search/content.js")
})
const Fail = asyncComponent({
  resolve: () => import("../component/fail/content.js")
})
const Code = asyncComponent({
  resolve: () => import("../component/code/content.js")
})
const Error = asyncComponent({
  resolve: () => import('./error.js')
})
const Devicemanage = asyncComponent({
  resolve: () => import("../component/devicemanage/content.js")
})
const menuList = {
  default : "/overview",
  list : [{
    title : "概览",
    key : "/overview",
    icon : 'page-overview',
    content : Overview,
    hide : false,
    authority : ["ADMIN", "SUPER"]
  },{
    title : "缴费项管理",
    key : "/product",
    icon : 'page-product',
    content : Product,
    hide : false,
    authority : ["ADMIN", "SUBADMIN", "SUPER"],
    sub : [{
      title : "新增缴费项",
      key : "/product/create",
    },{
      title : "编辑缴费项",
      key : "/product/edit",
    },{
      title : "缴费管理",
      key : "/product/manage",
    }]
  },{
    title : "外部缴费项管理",
    key : "/productex",
    icon : 'page-productex',
    content : Productex,
    hide : false,
    authority : ["ADMIN", "SUBADMIN", "SUPER"],
    sub : [{
      title : "新增缴费项",
      key : "/productex/create",
    },{
      title : "编辑缴费项",
      key : "/productex/edit",
    },{
      title : "缴费管理",
      key : "/productex/manage",
    }]
  },{
    title : "缴费分类管理",
    key : "/type",
    icon : 'page-type',
    content : Type,
    hide : false,
    authority : ["ADMIN", "SUPER"],
    sub : [{
      title : "创建分类",
      key : "/type/create",
    },{
      title : "修改分类",
      key : "/type/edit",
    }]
  },{
    title : "缴费统计管理",
    key : "/statis",
    icon : 'page-statis',
    content : Statis,
    hide : false,
    authority : ["ADMIN", "SUPER"]
  },{
    title : "缴费查询",
    key : "/search",
    icon : 'page-search',
    content : Search,
    hide : false,
    authority : ["ADMIN", "SUBADMIN", "SUPER"],
  },{
    title : "对账单下载",
    key : "/down",
    icon : 'page-down',
    content : Down,
    hide : false,
    authority : ["ADMIN", "SUBADMIN", "SUPER"],
  },{
    title : "子管理员",
    tip : "子管理员功能已整合至子账户中，将关闭新建子管理员功能，已创建账号仍可以使用。",
    key : "/sub",
    icon : 'page-sub',
    content : Sub,
    hide : false,
    authority : ["SUPER"],
    sub : [{
      title : "添加子管理员",
      key : "/sub/create",
    },{
      title : "编辑子管理员",
      key : "/sub/edit",
    }]
  },{
    title : "子帐户管理",
    key : "/account",
    icon : 'page-account',
    content : Account,
    hide : false,
    authority : ["ADMIN", "SUPER"],
    sub : [{
      title : "添加子账户",
      key : "/account/create",
    },{
      title : "编辑子账户",
      key : "/account/edit",
    }]
  },{
    key : "/login",
    content : Login,
    hide : true,
    authority : ["ADMIN","SUBADMIN","SUPER"],
  },{
    key : "/submanage",
    title : "缴费项管理",
    content : Submanage,
    hide : true,
    authority : ["SUBADMIN"],
    sub : [{
      title : "缴费管理",
      key : "/submanage/manage",
    }]
  },{
    title : "学校管理",
    key : "/school",
    icon : 'page-school',
    content : School,
    hide : false,
    authority : ["SUPER"],
    sub : [{
      title : "添加学校",
      key : "/school/create",
    }, {
      title : "编辑学校",
      key : "/school/edit",
    }, {
      title : "收款账户",
      key : "/school/subOrg",
      sub : [{
        title : "添加收款账户",
        key : "/school/subOrg/create",
      },{
        title : "修改收款账户",
        key : "/school/subOrg/edit",
      }]
    }, {
      title : "账号管理",
      key : "/school/account",
      sub : [{
        title : "添加账号",
        key : "/school/account/create",
      },{
        title : "修改账号",
        key : "/school/account/edit",
      }]
    }]
  },{
    title : "帮助中心",
    key : "/help",
    icon : 'info-circle',
    content : Help,
    hide : false,
    authority : ["ADMIN","SUBADMIN","SUPER"],
    sub : [{
      title : "目录",
      key : "/help/0",
    }, {
      title : "缴费通的主要功能",
      key : "/help/1",
    }, {
      title : "概览缴费通收款数据",
      key : "/help/2",
    }, {
      title : "管理缴费项",
      key : "/help/3",
    }, {
      title : "管理外部缴费项  ",
      key : "/help/4",
    }, {
      title : "管理缴费分类",
      key : "/help/5",
    }, {
      title : "查看缴费统计数据",
      key : "/help/6",
    }, {
      title : "查询缴费订单",
      key : "/help/7",
    }, {
      title : "下载对账单",
      key : "/help/8",
    }, {
      title : "管理子管理员",
      key : "/help/9",
    }, {
      title : "管理子账户",
      key : "/help/10",
    }]
  },{
    title : "订单异常查询",
    key : "/fail",
    icon : 'close-circle',
    content : Fail,
    hide : false,
    authority : ["ADMIN","SUBADMIN","SUPER"],
  },{
    title : "接入码",
    key : "/code",
    icon : 'code',
    content : Code,
    hide : false,
    authority : ["ADMIN","SUPER"],
  },{
    title : "设备管理",
    key : "/devicemanage",
    icon : 'qrcode',
    content : Devicemanage,
    hide : false,
    authority : ["ADMIN", "SUPER"],
    sub : [{
      title : "新增设备",
      key : "/devicemanage/create",
    },{
      title : "设备编辑",
      key : "/devicemanage/edit",
    }]
  },{
    key : "/404",
    content: Error,
    hide : true,
  },{
    key : "/403",
    content: Error,
    hide : true,
  },{
    key : "/500",
    content: Error,
    hide : true,
  }
]};
export default menuList;



// WEBPACK FOOTER //
// ./src/index/menulist.js